module.exports = __webpack_public_path__ + "static/media/start_school_01.e11ee8f6.png";